import { useListSchoolProgrammesLazyQuery } from '@/types/vue-apollo-helpers';

export const useProgrammes = ({
  autoFetch = false,
  first = 200,
  page = 1,
}: { autoFetch?: boolean; first?: number; page?: number }) => {
  const variables = ref({ first, page });

  const {
    result: schoolProgrammeResult,
    loading: loadingSchoolProgramme,
    refetch: refetchSchoolProgramme,
    load: loadSchoolProgramme,
    error: errorSchoolProgramme,
    onResult: onResultSchoolProgramme,
  } = useListSchoolProgrammesLazyQuery(variables.value);
  if (autoFetch) loadSchoolProgramme();

  const programmes = computed(() => schoolProgrammeResult.value?.listSchoolProgrammes?.data || []);
  const paginatorInfo = computed(() => schoolProgrammeResult.value?.listSchoolProgrammes?.paginatorInfo);

  const setPage = async(newPage: number) => {
    variables.value.page = newPage;
    await refetchSchoolProgramme({ ...variables.value });
  };

  const setItemsPerPage = async(newFirst: number) => {
    variables.value.first = newFirst;
    variables.value.page = 1; // reset to first page
    await refetchSchoolProgramme({ ...variables.value });
  };

  return {
    programmes,
    paginatorInfo,
    loadingSchoolProgramme,
    loadSchoolProgramme,
    refetchSchoolProgramme,
    errorSchoolProgramme,
    onResultSchoolProgramme,
    setPage,
    setItemsPerPage,
  };
};
